export default function StaticCallout({calloutText, calloutURL, calloutLabel}) {
    return (
      <div className="static-brandbar">
        <div className="order-cta-brandbar">
          <span role="heading" aria-level="2">{calloutText}</span>
          <a href={calloutURL} target="_blank" aria-label={`${calloutLabel} - opens in new tab/window`} tabIndex={1}>{calloutLabel}</a>
        </div>
      </div>
    );
  }